import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Skeleton from "react-loading-skeleton";
import withCustomStyles from "./SliderPart.style";
import SlidersListPart from "./SlidersListPart";

@inject(["slidersStore"])
@observer
class SliderPart extends Component {
  componentDidMount() {
    this.props.slidersStore.fetch();
  }

  render() {
    const { classes, slidersStore } = this.props;

    if (slidersStore.all.length === 0) {
      return slidersStore.state === "fetching" ? (
        <div className={classes.loading} aria-hidden="true">
          <Skeleton className={classes.skeleton} />
          <Skeleton className={classes.skeleton} />
        </div>
      ) : null;
    }

    return <SlidersListPart sliders={slidersStore.all} />;
  }
}

export default withCustomStyles(SliderPart);
